<template>
  <div
    id="external-order-item-container"
    class="w-full flex flex-row justify-start items-center py-3.5 border-b border-gray-200 text-gray-800"
  >
    <div
      id="order-item-image-container"
      class="mx-7 flex flex-row justify-center items-center"
    >
      <img
        v-if="localOrderItem.image"
        :src="localOrderItem.image"
        class="w-14 h-14 min-w-14 min-h-14 p-1 rounded-full border-gray-200"
      />
      <img
        v-else
        src="@/assets/load.gif"
        class="w-14 h-14 min-w-14 min-h-14 p-1 rounded-full border-gray-200"
      />
    </div>

    <div
      id="order-item-info-container"
      class="w-full flex flex-col justify-start items-stretch sm:flex-row sm:justify-between sm:items-center"
    >
      <div class="w-full flex flex-col justify-start items-stretch flex-1">
        <p class="font-semibold">{{ localOrderItem.name }}</p>
        <p class="mt-1">Data de entrega: {{ getDate(localOrderItem) }}</p>
      </div>
      <div class="mt-1 sm:mt-0">
        <p>Valor: {{ localOrderItem.invoice.charged_amount + localOrderItem.invoice.shipping_amount | currencyFormat }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import { addImagesInOrderItems as addImages } from '@/utils/csExternal/images'
import { currencyFormat } from '@/utils/utils'

export default {
  name: 'ExternalOrderItem',
  props: {
    orderItem: Object,
    organization: String
  },
  data () {
    return {
      localOrderItem: {}
    }
  },
  filters: {
    currencyFormat: value => currencyFormat(value)
  },
  created () {
    this.localOrderItem = this.orderItem
    this.setImage()
  },
  methods: {
    async setImage () {
      const itemWithImage = await addImages([this.localOrderItem], {}, this.organization)
      this.localOrderItem.image = itemWithImage[0].image
      this.$forceUpdate()
    },

    formatDate: value => dayjs(value).format('DD/MM/YYYY'),

    isCanceledOrderItem (item) {
      if (!item.last_status) return false

      const isCanceled =
        item.last_status.code.cluster === 'CANCELED_REFUND_NEEDED' ||
        item.last_status.code.cluster === 'CANCELED_CLOSED'

      return isCanceled
    },

    getDate (item) {
      if (this.isCanceledOrderItem(item)) return 'Item cancelado'

      const date = item.shipping.shipping_dates.agreement_delivery_date

      if (date) return this.formatDate(date)

      return '-'
    }
  }
}
</script>
